(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_banner-parent"] && !Shopify.designMode) return;
  try {
    function initBannerGrid() {
    const bannerParents = document.querySelectorAll('.banner-parent');
    bannerParents.forEach(function (bannerParent) {
      const bannerItems = bannerParent.querySelectorAll('.banner-item');
      bannerParent.classList.add('grid-' + bannerItems.length);
    });
  }

  initBannerGrid();  
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initBannerGrid);
    document.addEventListener('shopify:section:deselect', initBannerGrid);
    document.addEventListener('shopify:section:reorder', initBannerGrid);
    document.addEventListener('shopify:block:select', initBannerGrid);
    document.addEventListener('shopify:block:deselect', initBannerGrid);
    document.addEventListener('shopify:section:load', initBannerGrid);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_gs-bundle"] && !Shopify.designMode) return;
  try {
    window.gsMoney =
    window.gsMoney ||
    function (cents) {
      const format = window.themeGlobalVariables?.settings?.money_format;
      if (window.Shopify?.formatMoney && format) return Shopify.formatMoney(cents, format);
      return 'S/ ' + (cents / 100).toFixed(2);
    };

  if (!customElements.get('gs-bundle')) {
    customElements.define(
      'gs-bundle',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          const input = document.querySelector(`#product-form-${this.dataset.section} input[name="id"]`);
          this.mainId = input?.value || Object.keys(this.variants)[0];

          const picks = this.pickExtras(JSON.parse(this.querySelector('[data-pools]').textContent));
          if (!picks.length) {
            this.hidden = true;
            return;
          }
          const list = this.querySelector('[data-list]');
          picks.forEach((p, i) => list.append(this.buildRow(p, i, i === 0)));

          this.onVariant = (e) => {
            if (!e.target.matches(`#product-form-${this.dataset.section} input[name="id"]`)) return;
            this.mainId = e.target.value;
            this.render();
          };
          document.addEventListener('change', this.onVariant);
          this.addEventListener('change', () => this.render());
          this.querySelector('[data-add]').addEventListener('click', () => this.add());
          // Si la bolsa cambia desde otro botón (ej. "Agregar"), recalcula el aviso de envío gratis
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              if (event?.source === 'gs-bundle') return;
              fetch(`${window.routes?.cart_url || '/cart'}.js`)
                .then((r) => r.json())
                .then((cart) => {
                  this.dataset.cart = cart.items_subtotal_price;
                  this.render();
                })
                .catch(() => {});
            });
          }
          this.render();
        }
        disconnectedCallback() {
          if (this.onVariant) document.removeEventListener('change', this.onVariant);
          this.unsubscribe?.();
        }

        /* Un producto al azar por cada colección, sin repetir y (opcional) sin el mismo tipo */
        pickExtras(pools) {
          const used = new Set();
          const sameType = (this.dataset.type || '').trim().toLowerCase();
          const shuffle = (arr) => arr.map((v) => [Math.random(), v]).sort((a, b) => a[0] - b[0]).map((x) => x[1]);
          const key = (p) => p.variants[0]?.id;
          return pools
            .map((pool) => {
              const fresh = pool.filter((p) => p.variants.some((v) => v.available) && !used.has(key(p)));
              const preferred = sameType ? fresh.filter((p) => (p.type || '').trim().toLowerCase() !== sameType) : fresh;
              const pick = shuffle(preferred.length ? preferred : fresh)[0];
              if (pick) used.add(key(pick));
              return pick;
            })
            .filter(Boolean);
        }

        buildRow(p, i, checked) {
          const el = (tag, props = {}) => Object.assign(document.createElement(tag), props);
          const id = `gs-bundle-${this.dataset.block}-${i}`;
          const first = p.variants.find((v) => v.available) || p.variants[0];

          const row = el('li', { className: 'gs-bundle__item' });
          row.dataset.extra = '';
          row.append(el('input', { type: 'checkbox', id, checked }));

          const thumb = el('label', { className: 'gs-bundle__thumb', htmlFor: id });
          const startImage = first.image || p.image;
          if (startImage) thumb.append(el('img', { src: startImage, alt: p.title, loading: 'lazy', width: 60, height: 60 }));
          row.dataset.image = p.image || '';
          row.append(thumb);

          const info = el('span', { className: 'gs-bundle__info' });
          const name = el('label', { htmlFor: id });
          name.append(el('strong', { textContent: p.title }));
          info.append(name);

          if (p.single) {
            const hidden = el('input', { type: 'hidden', value: first.id });
            hidden.dataset.variant = '';
            hidden.dataset.price = first.price;
            info.append(hidden, el('small', { textContent: p.vendor }));
          } else {
            const select = el('select', { className: 'gs-bundle__select' });
            select.dataset.variant = '';
            select.setAttribute('aria-label', p.title);
            p.variants.forEach((v) => {
              const option = el('option', { value: v.id, textContent: v.title, disabled: !v.available, selected: v.id === first.id });
              option.dataset.price = v.price;
              option.dataset.image = v.image || '';
              select.append(option);
            });
            info.append(select);
          }
          row.append(info);

          const price = el('span', { className: 'gs-bundle__price' });
          price.dataset.linePrice = '';
          row.append(price);
          return row;
        }

        /* Cambia la miniatura; si la variante no tiene foto propia, usa la del producto */
        setThumb(thumb, src, alt) {
          if (!thumb || !src) return;
          let img = thumb.querySelector('img');
          if (!img) {
            img = Object.assign(document.createElement('img'), { alt, loading: 'lazy', width: 60, height: 60 });
            thumb.append(img);
          }
          if (img.getAttribute('src') !== src) {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = src;
          }
        }

        extras() {
          return [...this.querySelectorAll('[data-extra]')].map((row) => {
            const field = row.querySelector('[data-variant]');
            const option = field.tagName === 'SELECT' ? field.selectedOptions[0] : field;
            return { row, checked: row.querySelector('input[type="checkbox"]').checked, id: field.value, price: +option.dataset.price };
          });
        }

        render() {
          const main = this.variants[this.mainId];
          if (main) {
            this.querySelector('[data-main-price]').textContent = gsMoney(main.price);
            this.querySelector('[data-main-variant]').textContent = main.title === 'Default Title' ? '' : main.title;
            this.setThumb(this.querySelector('[data-main-thumb]'), main.image, main.title);
          }
          const extras = this.extras();
          extras.forEach((x) => {
            x.row.querySelector('[data-line-price]').textContent = gsMoney(x.price);
            const option = x.row.querySelector('select[data-variant]')?.selectedOptions[0];
            if (option) this.setThumb(x.row.querySelector('.gs-bundle__thumb'), option.dataset.image || x.row.dataset.image, option.textContent);
          });
          const chosen = extras.filter((x) => x.checked);
          const sum = (main?.price || 0) + chosen.reduce((a, x) => a + x.price, 0);
          const off = +this.dataset.discount * chosen.length;

          this.querySelector('[data-total]').textContent = gsMoney(sum - off);
          const was = this.querySelector('[data-was]');
          was.hidden = off <= 0;
          was.textContent = gsMoney(sum);
          const badge = this.querySelector('[data-save-badge]');
          badge.hidden = off <= 0 || !this.dataset.save;
          badge.textContent = this.dataset.save.replace('[amount]', gsMoney(off));
          const btn = this.querySelector('[data-add]');
          btn.disabled = !chosen.length;
          btn.textContent = this.dataset.button.replace('[count]', chosen.length + 1);

          const hint = this.querySelector('[data-hint]');
          const threshold = +this.dataset.threshold;
          const missing = threshold - (+this.dataset.cart + sum - off);
          const text = missing <= 0 ? this.dataset.hintDone : this.dataset.hintProgress.replace('[amount]', gsMoney(missing));
          hint.hidden = !threshold || !chosen.length || !text;
          hint.classList.toggle('is-done', missing <= 0);
          hint.textContent = text;
        }

        async add() {
          const btn = this.querySelector('[data-add]');
          const error = this.querySelector('[data-error]');
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const items = [{ id: +this.mainId, quantity: 1 }].concat(
            this.extras().filter((x) => x.checked).map((x) => ({ id: +x.id, quantity: 1 }))
          );
          const body = { items };
          if (cart?.getSectionsToRender) {
            body.sections = cart.getSectionsToRender().map((s) => s.id);
            body.sections_url = window.location.pathname;
          }
          btn.disabled = true;
          error.hidden = true;
          try {
            const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body),
            }).then((r) => r.json());

            if (res.status) {
              error.textContent = res.description || res.message;
              error.hidden = false;
              return;
            }
            if (!cart || !res.sections) {
              window.location = window.routes?.cart_url || '/cart';
              return;
            }
            cart.getSectionsToRender().forEach((section) => {
              const target = document.getElementById(section.id);
              const html = new DOMParser().parseFromString(res.sections[section.id] || '', 'text/html');
              const source = html.querySelector('#minicart-form');
              if (target && source) target.innerHTML = source.innerHTML;
            });
            cart.cartAction?.();
            cart.classList.remove('is-empty');
            cart.open?.();

            const fresh = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
            document.querySelectorAll('.cart-count').forEach((el) => {
              el.textContent = el.classList.contains('cart-count-drawer')
                ? `(${fresh.item_count})`
                : fresh.item_count > 100 ? '~' : fresh.item_count;
            });
            this.dataset.cart = fresh.items_subtotal_price;
            document.querySelector('free-ship-progress-bar')?.init?.(fresh.items_subtotal_price);
            document.querySelectorAll('gs-free-shipping').forEach((bar) => bar.refreshCart?.());
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gs-bundle', cartData: res });
            }
          } catch (e) {
            error.textContent = window.cartStrings?.error || 'No se pudo agregar. Inténtalo de nuevo.';
            error.hidden = false;
          } finally {
            this.render();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_gs-free-shipping"] && !Shopify.designMode) return;
  try {
    window.gsMoney =
    window.gsMoney ||
    function (cents) {
      const format = window.themeGlobalVariables?.settings?.money_format;
      if (window.Shopify?.formatMoney && format) return Shopify.formatMoney(cents, format);
      return 'S/ ' + (cents / 100).toFixed(2);
    };

  if (!customElements.get('gs-free-shipping')) {
    customElements.define(
      'gs-free-shipping',
      class extends HTMLElement {
        connectedCallback() {
          this.prices = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.cart = +this.dataset.cart;
          this.price = +this.dataset.price;
          this.form = document.getElementById(`product-form-${this.dataset.section}`);

          this.onChange = (e) => {
            if (!this.form || !this.form.contains(e.target)) return;
            if (e.target.name === 'id') this.price = this.prices[e.target.value] ?? this.price;
            this.render();
          };
          document.addEventListener('change', this.onChange);
          document.addEventListener('input', this.onChange);

          // PUB_SUB_EVENTS es un const global del tema (utils.js): no cuelga de window
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
          }
          this.render();
        }
        disconnectedCallback() {
          document.removeEventListener('change', this.onChange);
          document.removeEventListener('input', this.onChange);
          this.unsubscribe?.();
        }
        refreshCart() {
          fetch(`${window.routes?.cart_url || '/cart'}.js`)
            .then((r) => r.json())
            .then((cart) => {
              this.cart = cart.items_subtotal_price;
              this.render();
            })
            .catch(() => {});
        }
        render() {
          const qtyInput = this.form?.querySelector('[name="quantity"]');
          const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
          const threshold = +this.dataset.threshold;
          const total = this.cart + this.price * qty;
          const missing = threshold - total;
          const done = missing <= 0;
          this.classList.toggle('is-done', done);
          this.querySelector('[data-progress]').hidden = done;
          this.querySelector('[data-done]').hidden = !done;
          const amount = this.querySelector('[data-missing]');
          if (amount && !done) amount.textContent = gsMoney(missing);
          this.querySelector('.gs-ship__fill').style.width = Math.min(100, (total / threshold) * 100) + '%';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_gs-price-extras"] && !Shopify.designMode) return;
  try {
    window.gsMoney =
    window.gsMoney ||
    function (cents) {
      const format = window.themeGlobalVariables?.settings?.money_format;
      if (window.Shopify?.formatMoney && format) return Shopify.formatMoney(cents, format);
      return 'S/ ' + (cents / 100).toFixed(2);
    };

  if (!customElements.get('gs-price-extras')) {
    customElements.define(
      'gs-price-extras',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.onChange = (e) => {
            if (e.target.matches(`#product-form-${this.dataset.section} input[name="id"]`)) this.update(+e.target.value);
          };
          document.addEventListener('change', this.onChange);
        }
        disconnectedCallback() {
          document.removeEventListener('change', this.onChange);
        }
        update(id) {
          const v = this.variants.find((x) => x.id === id);
          if (!v) return;
          const saving = v.compare - v.price;
          const wrap = this.querySelector('[data-save-wrap]');
          if (wrap) {
            wrap.hidden = saving <= 0;
            const save = wrap.querySelector('[data-save]');
            if (save) save.textContent = gsMoney(saving);
          }
          const price = this.querySelector('[data-price]');
          if (price) price.textContent = gsMoney(v.price);
          const compare = this.querySelector('[data-compare]');
          if (compare) {
            compare.hidden = v.compare <= v.price;
            compare.textContent = gsMoney(v.compare);
          }
          const box = this.querySelector('[data-cuotas]');
          if (box) {
            box.hidden = v.price < +this.dataset.min;
            const cuota = box.querySelector('[data-cuota]');
            if (cuota) cuota.textContent = gsMoney(Math.floor(v.price / +this.dataset.installments));
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_gs-size-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-size-finder')) {
    customElements.define(
      'gs-size-finder',
      class extends HTMLElement {
        static STORAGE = 'gs-size-finder';

        connectedCallback() {
          this.config = JSON.parse(this.querySelector('[data-config]').textContent);
          this.rows = this.parseTable(this.config.table);
          if (!this.rows.length) return;
          this.sheet = this.querySelector('dialog');
          this.step = 1;

          this.querySelectorAll('[data-open]').forEach((b) => b.addEventListener('click', () => this.open()));
          this.sheet.addEventListener('click', (e) => {
            if (e.target === this.sheet || e.target.closest('[data-close]')) this.sheet.close();
          });
          this.querySelector('[data-next]').addEventListener('click', () => this.next());
          this.querySelector('[data-back]').addEventListener('click', () => this.goto(Math.max(1, this.step - 1)));
          this.querySelector('[data-apply]').addEventListener('click', () => this.apply(this.recommend().row.size));
          this.querySelectorAll('.gs-size__range').forEach((r) => {
            r.addEventListener('input', () => this.paintRange(r));
            this.paintRange(r);
          });

          const saved = this.load();
          if (saved) {
            this.fill(saved);
            this.showSaved();
          }
        }

        /* "M | 97-101 | 72 | L" por línea */
        parseTable(text) {
          return String(text || '')
            .split(/\r?\n/)
            .map((line) => line.split('|').map((x) => x.trim()))
            .filter((cols) => cols.length >= 2 && cols[0])
            .map(([size, chest, length, pe]) => {
              const [min, max] = chest.split('-').map((n) => parseFloat(n));
              return { size, min, max: max || min, length: length || '', pe: pe || '' };
            })
            .filter((r) => !isNaN(r.min));
        }

        paintRange(input) {
          const unit = input.hasAttribute('data-h') ? ' cm' : ' kg';
          this.querySelector(`[data-out="${input.hasAttribute('data-h') ? 'h' : 'w'}"]`).textContent = input.value + unit;
        }

        values() {
          return {
            h: +this.querySelector('[data-h]').value,
            w: +this.querySelector('[data-w]').value,
            body: +this.querySelector('input[name^="gs-body"]:checked').value,
            pref: +this.querySelector('input[name^="gs-pref"]:checked').value,
          };
        }

        fill(v) {
          this.querySelector('[data-h]').value = v.h;
          this.querySelector('[data-w]').value = v.w;
          const body = this.querySelector(`input[name^="gs-body"][value="${v.body}"]`);
          const pref = this.querySelector(`input[name^="gs-pref"][value="${v.pref}"]`);
          if (body) body.checked = true;
          if (pref) pref.checked = true;
          this.querySelectorAll('.gs-size__range').forEach((r) => this.paintRange(r));
        }

        load() {
          try {
            const v = JSON.parse(localStorage.getItem(this.constructor.STORAGE));
            return v && v.h && v.w ? v : null;
          } catch (e) {
            return null;
          }
        }

        save(v) {
          try {
            localStorage.setItem(this.constructor.STORAGE, JSON.stringify(v));
          } catch (e) {}
        }

        /* Pecho estimado (aprox.) por altura y peso, ajustado por contextura, preferencia y calce de la prenda */
        recommend() {
          const { h, w, body, pref } = this.values();
          const fitExtra = { ajustado: 2, regular: 0, holgado: -2 }[this.config.fit] || 0;
          const chest = 0.5 * h + 0.45 * (w - 22 * (h / 100) ** 2) + 9 + body + pref + fitExtra;
          let i = this.rows.findIndex((r) => chest <= r.max);
          if (i < 0) i = this.rows.length - 1;
          const row = this.rows[i];
          const mid = (row.min + row.max) / 2;
          const half = (row.max - row.min) / 2 + 1;
          const dist = Math.abs(chest - mid);
          const outside = chest < this.rows[0].min - 4 || chest > this.rows[this.rows.length - 1].max + 4;
          const conf = outside ? 55 : Math.max(55, Math.min(96, Math.round(96 - (dist / half) * 26)));
          const alt = dist / half > 0.6 ? this.rows[chest > mid ? i + 1 : i - 1] || null : null;
          return { row, conf, alt };
        }

        isAvailable(size) {
          const map = this.config.available;
          const key = Object.keys(map).find((k) => k.toLowerCase() === size.toLowerCase());
          return key ? map[key] : false;
        }

        open() {
          this.goto(1);
          this.sheet.showModal();
        }

        goto(n) {
          this.step = n;
          this.querySelectorAll('[data-step]').forEach((s) => (s.hidden = +s.dataset.step !== n));
          this.querySelectorAll('.gs-size__steps i').forEach((b, k) => b.classList.toggle('is-on', k < n));
          this.querySelector('[data-back]').hidden = n === 1;
          const next = this.querySelector('[data-next]');
          next.classList.toggle('is-final', n === 4);
          next.textContent = n === 3 ? 'Ver mi talla' : 'Siguiente';
          if (n === 4) this.showResult();
          this.querySelector('[data-body]').scrollTop = 0;
        }

        next() {
          if (this.step < 4) return this.goto(this.step + 1);
          const { row } = this.recommend();
          if (this.isAvailable(row.size)) this.apply(row.size);
          this.sheet.close();
        }

        showResult() {
          const { row, conf, alt } = this.recommend();
          const t = this.config.texts;
          const available = this.isAvailable(row.size);
          this.save(this.values());

          this.querySelector('[data-r-size]').textContent = row.size;
          this.querySelector('[data-r-title]').textContent = t.result.replace('[size]', row.size);
          const sub = [];
          if (this.config.showPeru && row.pe) sub.push(t.peru.replace('[size]', row.pe));
          sub.push(available ? 'Disponible para comprar.' : 'Ahora está agotada.');
          this.querySelector('[data-r-sub]').textContent = sub.join(' ');
          this.querySelector('[data-r-conf]').style.width = conf + '%';
          this.querySelector('[data-r-conf-label]').textContent = conf >= 85 ? 'Muy seguro' : conf >= 70 ? 'Seguro' : 'Revisa la tabla';

          const altBox = this.querySelector('[data-r-alt]');
          altBox.hidden = !alt;
          if (alt) {
            const bigger = this.rows.indexOf(alt) > this.rows.indexOf(row);
            altBox.textContent = `Estás cerca de la ${alt.size}. Si prefieres ${bigger ? 'más espacio' : 'que quede más ajustado'}, elige ${alt.size}.`;
          }

          const tbody = this.querySelector('[data-r-table]');
          tbody.replaceChildren();
          this.rows.forEach((r) => {
            const tr = document.createElement('tr');
            if (r === row) tr.className = 'is-rec';
            const cells = [r.size, `${r.min}–${r.max} cm`, r.length ? `${r.length} cm` : '—'];
            if (this.config.showPeru) cells.push(r.pe || '—');
            cells.forEach((v) => {
              const td = document.createElement('td');
              td.textContent = v;
              tr.append(td);
            });
            tbody.append(tr);
          });

          this.querySelector('[data-next]').textContent = available ? t.choose.replace('[size]', row.size) : 'Cerrar';
          this.showSaved();
        }

        showSaved() {
          const { row } = this.recommend();
          const v = this.values();
          const box = this.querySelector('[data-saved]');
          box.hidden = false;
          this.querySelector('[data-saved-text]').textContent = this.config.texts.saved
            .replace('[size]', row.size)
            .replace('[height]', v.h)
            .replace('[weight]', v.w);
          this.querySelector('[data-apply]').hidden = !this.isAvailable(row.size);
        }

        /* Marca la talla en el selector del tema (hace clic en su opción para que el tema actualice precio y stock) */
        apply(size) {
          const root = this.closest('.product-detail__information') || document;
          const inputs = [...root.querySelectorAll('.product-detail__variant-picker input[type="radio"]')].filter(
            (i) => i.name === this.config.option && i.value.trim().toLowerCase() === size.toLowerCase()
          );
          const input = inputs.find((i) => !i.classList.contains('option-disabled')) || inputs[0];
          root.querySelectorAll('.gs-size-rec').forEach((l) => l.classList.remove('gs-size-rec'));
          root.querySelectorAll('.gs-size-badge').forEach((b) => b.remove());
          if (!input) return;
          if (!input.checked) input.click();
          const label = root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          if (label) {
            label.classList.add('gs-size-rec');
            const badge = document.createElement('span');
            badge.className = 'gs-size-badge';
            badge.textContent = this.config.texts.badge;
            label.append(badge);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-parent"] && !Shopify.designMode) return;
  try {
    function addAnimateDelayToSlides() {
    const swiperWrappers = document.querySelectorAll('.swiper-wrapper_parent');
    swiperWrappers.forEach(function(swiperWrapper) {
      const slideItems = swiperWrapper.querySelectorAll('.swiper-slide_item');
      slideItems.forEach(function(slideItem, index) {
        if (index > 0) {
          const contentSlides = slideItem.querySelectorAll('.content-slide');
          contentSlides.forEach(function(contentSlide) {
            contentSlide.classList.add('animate-delay');
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', addAnimateDelayToSlides);
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:reorder', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:load', addAnimateDelayToSlides);
  }
  } catch(e) { console.error(e); }
})();

})();
